import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import { useAppSelector } from "../../services/hooks";
import { Link } from "react-router";
import { formatPrice } from "../../helpers/formatPrice";
import { useTranslation } from "react-i18next";

export default function ProductRecomendations() {
    const { t } = useTranslation('productPage')
    const recommended = useAppSelector((state) => state.product.data?.recommended)
    const currency = useAppSelector((state) => state.user?.currency)

    const showRecommended = recommended?.map((item) => (
        item && <Col xs={12} md={6} xl={12} className="px-4 pt-3">
            <Link to={`/product/${item.url ?? ""}`} className="noUnderline link-dark">
                <Row>
                    <strong className="text-white text-center small bg-success w-50 ms-auto py-1 rounded-top-3"><small>{t('recommends')}</small></strong>
                </Row>
                <Row className="border rounded-bottom-4 rounded-start-4 shadow-sm bg-body-tertiary border-secondary-subtle p-3">
                    <Col xs={6} md={12} className="align-self-center mx-auto g-0">
                        <img src={item.imgUrl} className="img-fluid shadow-sm  rounded-3" alt="" />
                    </Col>
                    <Col xs={6} md={12} className="text-center small py-2 align-self-center">
                        <div>{item.name}</div>
                        <strong>{formatPrice(item.price, currency)}</strong>
                    </Col>
                </Row>
            </Link>
        </Col>
    ))

    return (
        <Col xs={12} xl={2}>
            <Row className="mb-3">
                {recommended && <h3 className="text-center my-3">{t('recommended')}</h3>}
                {showRecommended}
            </Row>
        </Col>
    )
}